import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.content_list-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".content_list-swiper");
        const buttons = [...layout.querySelectorAll(".list-button")];
        const slides = swiperEl ? [...swiperEl.querySelectorAll(".swiper-slide")] : [];
        if (!swiperEl || slides.length < 2) return;

        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        let pausedByUser = false;

        const setActive = (index) => {
            buttons.forEach((button, i) => {
                const isActive = i === index;
                button.classList.toggle("is-active", isActive);
                if (isActive) button.setAttribute("aria-current", "true");
                else button.removeAttribute("aria-current");
            });

            slides.forEach((slide) => {
                slide.inert = slide.id !== buttons[index]?.getAttribute("aria-controls");
            });
        };

        const swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            speed: reducedMotion ? 0 : 400,
            effect: "fade",
            fadeEffect: { crossFade: true },
            loop: true,
            autoplay: reducedMotion ? false : { delay: 10000, disableOnInteraction: true },
            pagination: {
                el: layout.querySelector(".content_list-pagination"),
                clickable: true,
                bulletClass: "content_list-bullet",
                bulletActiveClass: "is-active",
                renderBullet: (index, className) => `<button type="button" class="${className}"></button>`,
            },
            a11y: {
                enabled: true,
                paginationBulletMessage: "Ga naar item {{index}}",
                slideLabelMessage: "Item {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                0: { allowTouchMove: true },
                993: { allowTouchMove: false },
            },
            on: {
                init: (s) => setActive(s.realIndex),
                slideChange: (s) => setActive(s.realIndex),
            },
        });

        const stop = () => {
            pausedByUser = true;
            swiper.autoplay?.stop();
        };

        buttons.forEach((button, i) => {
            button.addEventListener("click", () => {
                stop();
                swiper.slideToLoop(i);
            });
        });

        swiperEl.addEventListener("touchstart", stop, { passive: true });
        layout.querySelector(".content_list-pagination")?.addEventListener("click", stop);

        const pause = () => swiper.autoplay?.pause();
        const resume = () => {
            if (!pausedByUser && !layout.matches(":hover, :focus-within")) swiper.autoplay?.resume();
        };

        layout.addEventListener("mouseenter", pause);
        layout.addEventListener("mouseleave", resume);
        layout.addEventListener("focusin", pause);
        layout.addEventListener("focusout", () => setTimeout(resume));
    });
});
